export const ServiceRequired = "ServiceRequired";
export const PrivacyConsent = "PrivacyConsent";
export const EmployeeAwareConsent = "EmployeeAwareConsent";
export const DataSecureConsent = "DataSecureConsent";
export const LineManagerId = "LineManagerId";
export const LineManagerName = "LineManagerName";
export const LineManagerEmail = "LineManagerEmail";
export const LineManagerPhone = "LineManagerPhone";
export const HrName = "HrName";
export const HrEmail = "HrEmail";
export const PurchaseOrderNumber = "PurchaseOrderNumber";
export const ReferredTitle = "ReferredTitle";
export const ReferredFirstName = "ReferredFirstName";
export const ReferredLastName = "ReferredLastName";
export const ReferredDob = "ReferredDob";
export const ReferredGender = "ReferredGender";
export const EmployeeId = "EmployeeId";
export const JobTitle = "JobTitle";
export const AddressLine1 = "AddressLine1";
export const AddressLine2 = "AddressLine2";
export const AddressLine3 = "AddressLine3";
export const City = "City";
export const County = "County";
export const Postcode = "Postcode";
export const PersonalEmailAddress = "PersonalEmailAddress";
export const ConfirmPersonalEmailAddress = "ConfirmPersonalEmailAddress";
export const MobilePhone = "MobilePhone";
export const HomePhone = "HomePhone";
export const WorkPhone = "WorkPhone";
export const OrgLevel1Id = "OrgLevel1Id";
export const OrgLevel1Name = "OrgLevel1Name";
export const OrgLevel2Id = "OrgLevel2Id";
export const OrgLevel2Name = "OrgLevel2Name";
export const OrgLevel3Id = "OrgLevel3Id";
export const OrgLevel3Name = "OrgLevel3Name";
export const OrgLevel4Id = "OrgLevel4Id";
export const OrgLevel4Name = "OrgLevel4Name";
export const ShiftPattern = "ShiftPattern";
export const StandardHours = "StandardHours";
export const TotallyConfidential = "TotallyConfidential";
export const SupportingDocumentsHeader = "SupportingDocumentsHeader";
export const FurtherInformation = "FurtherInformation";
export const FurtherQuestions = "FurtherQuestions";
